<template>
  <div 
    id="module-content-component"
    :class="{
      'position-absolute' : $store.state.module.view_dark,
      'h-100': !isMobile
    }"
    style="width: 100%;"
  >
    <v-container class="h-100">
      <v-row class="h-100">
        <v-col
          order="1"
          order-md="2"
        >
          <div class="d-flex flex-column h-100">
            <v-container>
              <v-row>
                <v-col
                  order="last"
                  order-md="first"
                  :cols="12"
                  :sm="12"
                  :md="6"
                  :lg="6"
                >
                  <div v-if="content && content.type == 'video'">
                    <p
                      class="mb-0 font-weight-bold text-uppercase"
                      :class="{
                        'white--text': $store.state.module.view_dark
                      }"
                    >
                      Progresso no vídeo: <span
                        :class="{
                          'purple--text ' : !$store.state.module.view_dark,
                          'white--text ' : $store.state.module.view_dark
                        }"
                      > {{ percentage_watched }}%</span>
                    </p>
                    <v-progress-linear
                      v-if="!content.is_video"
                      :value="percentage_watched"
                      class="rounded-pill mr-2"
                      :color="$store.state.module.view_dark ? 'white' : 'purple'"
                      height="15"
                    />  
                  </div>
                  <div v-if="activeTab == contents.length && !isMobile">
                    <p
                      class="text-uppercase m-0"
                      :class="{
                        'white--text': $store.state.module.view_dark
                      }"
                    >
                      Videocast
                    </p>
                    <p
                      class="mb-0 font-weight-bold"
                      :class="{
                        'white--text': $store.state.module.view_dark
                      }"
                    >
                      {{ module.video.title }}
                    </p>
                  </div>
                </v-col>
                <v-col
                  :md="6"
                  :lg="6"
                  :sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-md-end"
                >
                  <NavigationButtons />
                </v-col>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <v-col
                  :class="{ 
                    'pr-0': $vuetify.breakpoint.lgAndUp
                  }"
                  md="11"
                  cols="12"
                >
                  <div 
                    class="d-flex flex-column justify-content-between h-100" 
                  >
                    <div class="p-0 position-relative flex-grow-1 d-flex flex-column justify-content-center">
                      <v-carousel
                        v-model="activeTab"
                        :height="'100%'"
                        :show-arrows="false"
                        hide-delimiters
                      >
                        <v-carousel-item
                          v-for="(item, i) in contents"
                          :key="i"
                        >
                          <component 
                            :is="componentNames[item.type]"
                            v-if="item.id == content.id"
                          />
                        </v-carousel-item>
                        <v-carousel-item :key="contents.length">
                          <Videocast />
                        </v-carousel-item>
                      </v-carousel>
                    </div>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex justify-content-center justify-content-md-end pr-0 py-0"
                  :class="{'px-0': $vuetify.breakpoint.lgAndUp}"
                  md="1"
                >
                  <ContentActionsMenu />
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import MiddlePercentage from '@/common/components/MiddlePercentage.vue'
import {  accessContent } from '@/student/api/Content.js'
import { mapActions, mapGetters } from 'vuex'
import ModuleContentMenu from './ModuleContentMenu.vue'
import QuestionsComponent from './QuestionComponent'
import ScormComponent from './ScormComponent'
import VideoComponent from './VideoComponent.vue'
import PageComponent from './PageComponent'
import ActiveTabMixin from './ActiveTabMixin'
import TicketCreate from "@/common/components/TicketCreate";
import NavigationButtons from './NavigationButtons.vue'
import ContentActionsMenu from './ContentActionsMenu.vue'
import VideocastButton from './VideocastButton.vue'
import Videocast from './Videocast.vue';


export default {
  components: {
    TicketCreate,
    ModuleContentMenu,
    MiddlePercentage,
    QuestionsComponent,
    PageComponent,
    ScormComponent,
    VideoComponent,
    NavigationButtons,
    ContentActionsMenu,
    VideocastButton,
    Videocast,
  },
  mixins: [ActiveTabMixin],
  data() {
    return {
      videoPercentage: 0,
      contentReleasedToFinish: false,
      request_time: 0,
      slow_time: 15,
    }
  },
  computed: {
    ...mapGetters(['module','contents','content','accessing_content']),
    componentNames() {
      return {
        page: PageComponent,
        quiz: QuestionsComponent,
        scorm: ScormComponent,
        video: VideoComponent,
      }
    },
    percentage_watched() {
      if (this.content && this.content.percentage_watched) {
        return Math.trunc(this.content.percentage_watched)
      }
      return 0
    },
  },
  watch: {
    activeTab: {
      handler() {
        if(this.content && !this.accessing_content) {
          this.load()
          accessContent(this.content.id)
          .finally(() => this.load(false))
        }
      },
      immediate: true
    }
  },
  
  methods: {
    ...mapActions(['load']),
  }
}
</script>
